<template>
  <common-template>
        <div class="list">
            <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
            <div class="search inner">
              <div class="title accordion d-flex justify-content-between align-items-center" id="accordionDrawing-header" data-toggle="collapse" data-target=".accordionDrawing" aria-controls="searchContent searchButton">
                <h2>{{ $t("検索条件") }}</h2>
                <div class="accordion-toggle-btn">
                  <b-button block id="accordionDrawing-up">{{ $t('閉じる') }}</b-button>
                  <b-button block id="accordionDrawing-down">{{ $t('開く') }}</b-button>
                </div>
              </div>
              <div id="searchContent" class="accordionDrawing content collapse" aria-labelledby="accordionDrawing-header">
                <div class="d-flex flex-row">
                  <div class="m-3 d-flex flex-row align-items-center justify-content-start form-group">
                    <label for="search-status" class="label">{{ $t("工場") }}:&nbsp;</label>
                    <select class="custom-select select" id="id_factory" v-model="form.site">
                      <option selected></option>
                      <template v-for="(item ,index) in mixinSpacesListDisplay('site')" :keyed="`site-${index}`">
                        <option :value="item.id" :key="`site-${index}`">{{ item.name }}</option>
                      </template>
                    </select>
                    <label for="search-status" class="label ml-3">{{ $t("部署") }}:&nbsp;</label>
                    <select name="factory" class="input form-control" id="id_department" v-model="form.dep">
                      <option value=""></option>
                      <template v-for="(item ,index) in mixinSpacesListDisplay('dep')" :keyed="`dep-${index}`">
                        <option :value="item.id" :key="`dep-${index}`">{{ item.name }}</option>
                      </template>
                    </select>
                  </div>
                </div>
              </div>
            <div id="searchButton" class="button accordionDrawing collapse">
              <button class="btn btn-info" @click="handleSearch()">
                {{ $t("検索") }}
              </button>
            </div>
          </div>
          <div class="inner d-flex justify-content-end mt-4 mb-4">
            <button type="button" class="btn btn-success create-btn" @click="createModalOpen()">
              {{ $t("登録") }}
          </button>
        </div>
        <div class="table-list inner">
          <h2 class="title">{{ $t("検索結果") }}</h2>
            <div class="content">
              <table class="table table-bordered">
                <thead class="thead">
                  <tr>
                    <th width="150" scope="col">{{ $t("工場") }}</th>
                    <th width="150" scope="col">{{ $t("部署") }}</th>
                    <th width="170" scope="col">{{ $t("工程/設備名") }}</th>
                    <th width="150" scope="col">{{ $t("工程区分") }}</th>
                    <th width="120" scope="col">{{ $t("時間単価") }}</th>
                    <th width="140" scope="col"></th>
                    <th width="160" scope="col"></th>
                    <th width="100" scope="col"></th>
                  </tr>
                </thead>
                <tbody class="tbody">
                  <template v-if="!load && this.list.length">
                    <tr v-for="(item, index) in this.list" :key="index">
                      <td>{{ mixinSpacesDisplay(item.site) }}</td>
                      <td>{{ mixinSpacesDisplay(item.dep) }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ $t(mixinProcessKindDisplay(item.processKindId)) }}</td>
                      <td>{{ item.hourPrice | mixinCommaDisplay }}</td>
                      <td><button type="button" class="btn-light btn"
                        @click="createModalOpen(item)">{{ $t("編集") }}</button></td>
                      <td><button type="button" class="btn-success btn"
                        @click="assignedModalOpen(item)">{{ $t("使用可能人員設定") }}</button></td>
                      <td><button type="button" class="btn-danger btn" @click="deleteAlert(item)">{{ $t("削除") }}</button></td>
                    </tr>
                  </template>
                  <template v-else-if="!load && !this.list.length">
                    <tr>
                      <td rowspan="2" colspan="99" class="text-center">
                        {{ $t("ノーデータメッセージ") }}
                      </td>
                    </tr>
                  </template>
                  <template v-else-if="load">
                    <tr>
                      <td colspan="12">
                        <div class="d-flex justify-content-center m-5" v-if="load">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <paginate
           v-model="mixinCurrentPage"
           :page-count="mixinGetPageCount"
           :force-page="mixinGetForcePage"
           :page-range="3"
           :margin-pages="1"
           :click-handler="handlePageChanged"
           :prev-text="'«'"
           :next-text="'»'"
           :container-class="'pagination justify-content-end'"
           :page-class="'page-item'"
           :page-link-class="'page-link'"
           :prev-class="'page-item'"
           :prev-link-class="'page-link'"
           :next-class="'page-item'"
           :next-link-class="'page-link'"
           ref="page"
          ></paginate>
          <create-modal
            ref="createModal"
            @registed="init()"
          ></create-modal>
          <assigned-modal
            ref="assignedModal"
            @registed="init()"
          ></assigned-modal>
      </div>
  </common-template>
</template>

<script>
import assignedModal from './assignedModal'
import createModal from './createModal'
// import passwordResetModal from './passwordResetModal'

import { mapGetters } from 'vuex'
import searchHelper from '../../mixin/search-helper'

export default {
  mixins: [searchHelper],
  data() {
    return {
      list: [],
      form: {
        site: null,
        dep: null,
      },
      master: {},
      processKinds: [],
      load: false,
      pageTitle: '工程情報一覧',
    }
  },
  components: {
    createModal,
    assignedModal,
    // passwordResetModal,
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    this.load = true
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(this.$t('データ取得エラーメッセージ'))
    }
    await this.getProcessKindsData()
    await this.getMasterData()
    await this.search()
    await this.init()
    this.load = false
  },
  methods: {
    async getMasterData() {
      try {
        this.master = []
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/masters`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.master = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async getProcessKindsData() {
      try {
        this.master = []
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/process/kinds`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.processKinds = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async search(isSearch = true) {
      this.load = true
      let params = {}
      if (isSearch) {
        if (this.form.site) params.site = this.form.site
        if (this.form.dep) params.dep = this.form.dep
      }
      try {
        this.list = []
        let headers = {
            'Authorization': this.authorization ? this.authorization : null,
        }
        const res = await this.mixinGetPageList(`${this.$appConfig.CommonApiUrl}/processes`, params, headers)
        this.list = res
        this.load = false
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    createModalOpen(item = {}) {
      this.$refs.createModal.createModalOpen(item, this.processKinds, this.master)
    },
    assignedModalOpen(item) {
      this.$refs.assignedModal.modalOpen(item, this.processKinds, this.master)
    },
    async deleteAlert(item) {
      const confirm = await this.$swal({
        text: this.$t(`${item.name}`) + this.$t('削除確認メッセージ'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: '',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {
          const params = {}
          params['id'] = item.id
          params['code'] = item.code || ''
          params['name'] = item.name
          params['division'] = item.division
          params['isOperativeBreakTime'] = item.isOperativeBreakTime
          params['isOperativeNonRegularTime'] = item.isOperativeNonRegularTime
          params['site'] = item.site || null
          params['dep'] = item.dep || null
          params['hourPrice'] = item.hourPrice || (item.hourPrice === 0 ? 0 : null)
          params['iot1'] = item.iot1 || ''
          params['iot2'] = item.iot2 || ''
          params['iot3'] = item.iot3 || ''
          params['iot4'] = item.iot4 || ''
          params['iot5'] = item.iot5 || ''
          params['processKindId'] = item.processKindId
          params['sort'] = item.sort || (item.sort === 0 ? 0 : null)
          params['isDelete'] = true
          await this.$axios.put(
            `${this.$appConfig.CommonApiUrl}/process`, params,
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
            }
          )
          this.$swal.close()
          this.$toasted.success(this.$t('データ削除完了メッセージ'))
          this.init()
        } catch (err) {
          console.log(err)
          this.$toasted.show(this.$t('データ削除エラーメッセージ'))
        }
      }
    },
    init() {
      this.search()
    },
    async handlePageChanged(pageNum) {
      this.mixinSetPageNumber(pageNum)
      await this.search(true)
    },
    async handleSearch() {
      this.mixinSetPageNumber(1)
      await this.search(true)
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style lang="scss" scoped>
</style>
